export default{
    updateActiveModalData(state, activeModal){
        state.activeModalData = {...state.activeModalData, ...activeModal}
    }
}